import { Bank } from '../BankTransfer/types'
import {
  SUBMIT_DEPOSIT,
  SUBMIT_DEPOSIT_CLEAR,
  SUBMIT_DEPOSIT_ERROR,
  SUBMIT_DEPOSIT_SUCCESS
} from './actionTypes'
import { SubmitDepositResponse } from './types'

export interface SubmitDepositAction {
  payload: {
    amount: string
    currency: string
    paymentMethod: Bank
  }
  type: typeof SUBMIT_DEPOSIT
}
export const submitDeposit = (
  amount: string,
  currency: string,
  paymentMethod: Bank
): SubmitDepositAction => ({
  payload: { amount, currency, paymentMethod },
  type: SUBMIT_DEPOSIT
})

export interface SubmitDepositSuccessAction {
  payload: SubmitDepositResponse
  type: typeof SUBMIT_DEPOSIT_SUCCESS
}
export const submitDepositSuccess = (data: SubmitDepositResponse): SubmitDepositSuccessAction => ({
  payload: data,
  type: SUBMIT_DEPOSIT_SUCCESS
})

export interface SubmitDepositErrorAction {
  payload: string
  type: typeof SUBMIT_DEPOSIT_ERROR
}
export const submitDepositError = (data: string): SubmitDepositErrorAction => ({
  payload: data,
  type: SUBMIT_DEPOSIT_ERROR
})

export interface ClearSubmitDepositAction {
  type: typeof SUBMIT_DEPOSIT_CLEAR
}
export const clear = (): ClearSubmitDepositAction => ({
  type: SUBMIT_DEPOSIT_CLEAR
})

export type SubmitDepositActions =
  | SubmitDepositAction
  | SubmitDepositSuccessAction
  | SubmitDepositErrorAction
  | ClearSubmitDepositAction
